import axios from 'axios'
import { SSO_CLIENT_ID } from '@/components/common/constants.js'
const state = {
  token: null,
  isLoggedIn: false
}

const getters = {
  getToken: state => { return state.token },
  getIsLoggedIn: state => { return state.isLoggedIn }
}

const mutations = {
  setIsLoggedIn (state, isLogged) {
    state.isLoggedIn = isLogged
  },
  setToken (state, data) {
    // console.log('setting token')
    state.token = data
  },
  deleteToken (state) {
    // console.log('deleting token')
    state.token = null
  }

}

const actions = {
  // setUserStoreData - initializes store data for user
  // [5/6/18] currently called from headerLogin.vue to initialize third party user registered on liveDemy and logins through third party forms
  setUserStoreData (context, data) {
    return new Promise((resolve) => {
      context.commit('setCartData', data.cartDetails)
      context.commit('setProfileDetails', data.profileDetails)
      context.commit('setWishListStoreData', data.wishListItems)
      context.commit('setUserPlaylists', data.userPlaylists)
      context.commit('setItemsEnrolled', data.enrolledLearningObject) // storing all LOs and COs purchased by user
      context.commit('setIsLoggedIn', true)
      resolve(true)
    })
  },
  // userSignIn - gets token from SSO server and initialized thee store data for user
  // [5/6/18] currently called from headerLogin.vue to initialize liveDemy and third party
  userSignIn (context, data) {
    return new Promise((resolve, reject) => {
      window.MKCLAPI.login(data.username, data.password).then(function (token) {
        context.commit('setToken', token)
        axios.get('/o/loginForSocialUser', {headers: {'clientId': SSO_CLIENT_ID, 'Authorization': token, 'jvId': data.jvId, 'linkingPermission': data.linkingPermission}}).then(function (response) {
          if (response.status === 200) {
            var userData = response.data
            // console.log(JSON.stringify(response.data))
            context.commit('setCartData', userData.cartDetails)
            context.commit('setProfileDetails', userData.profileDetails)
            context.commit('setWishListStoreData', userData.wishListItems)
            context.commit('setUserPlaylists', userData.userPlaylists)
            context.commit('setItemsEnrolled', userData.enrolledLearningObject) // storing all LOs and COs purchased by user
            context.commit('setIsLoggedIn', true)
            localStorage.setItem('isLoggedIn', true)
            localStorage.setItem('token', token)
            localStorage.setItem('ssoToken', true)
            resolve('success')
          }
        }).catch(function (e) {
          console.log('Failed to initialize user Profile' + e.response.data)
          reject(new Error('Failed to initialize user Profile' + e.response.data))
        })
      }).catch((e) => {
        console.log('FAILED_TO_GET_TOKEN_FROM_SSO : ', e)
        reject(e)
      })
    })
  },
  // logoutThirdPartyUser - deletes the session from redux server
  // returns true if session is deleted successfully
  logoutThirdPartyUser (context) {
    return new Promise((resolve, reject) => {
      axios
       .get('r/logoutThirdPartyUser')
       .then(res => {
         resolve(true)
       })
       .catch(err => {
         console.log('ERROR_IN_REMOVING_SESSION : ', err)
         reject(err)
       })
    })
  },
  // signInThirdPartyUser - initialize store data for third party user (token => data, isLoggedIn => true, ssoToken => false)
  signInThirdPartyUser (context, data) {
    return new Promise((resolve, reject) => {
      axios.get('/o/loginForSocialUser', null, {headers: { 'Authorization': data }}).then(function (response) {
        if (response.status === 200) {
          context.commit('setCartData', response.data.cartDetails)
          context.commit('setProfileDetails', response.data.profileDetails)
          context.commit('setWishListStoreData', response.data.wishListItems)
          context.commit('setUserPlaylists', response.data.userPlaylists)
          context.commit('setItemsEnrolled', response.data.enrolledLearningObject) // storing all LOs and COs purchased by user
          context.commit('setIsLoggedIn', true)
          resolve()
        }
      }).catch(function (e) {
        console.log('ERROR_IN_INTILIALIZING_THIRD_PARTY_PROFILE : ', e)
        reject(e)
      })
    })
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js